import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=1f3205fe"
import script from "./DialogWrapper.vue?vue&type=script&lang=js"
export * from "./DialogWrapper.vue?vue&type=script&lang=js"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=1f3205fe&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports